import { Accordion } from '@vfde-brix/ws10/accordion';
import { trackAccordion } from '../tracking/tracking';
import { closeAccordion } from './accordion';
import { TrackingUIType } from '../tracking/enum';

const FOOTNOTE_INITIALIZED = 'initialized';

const clickHandler = (accordion: Accordion, target: EventTarget | null) => {
    const { items } = accordion.getProperties();

    if (!target || !(target instanceof HTMLElement)) {
        return;
    }

    const index = +target.innerText - 1;
    const item = items[index];

    if (!item) {
        return;
    }

    const footnoteText = target.parentNode?.childNodes[0].textContent || '';

    trackAccordion(footnoteText, TrackingUIType.Footnote);

    closeAccordion(accordion);
    accordion.toggleItemById(item.stdId, true);
};

/**
 * Loop through all <sup> elements and add tracking on click where it is not initialized
 * @param {Accordion | null} accordion - accordion brix component
 */
export const initFootnotes = (accordion: Accordion | null) => {
    if (!accordion) {
        return;
    }

    const footnoteElements = document.getElementsByTagName('sup');

    for (const footnoteEl of footnoteElements) {
        if (footnoteEl.classList.contains(FOOTNOTE_INITIALIZED)) {
            continue;
        }

        footnoteEl.addEventListener('click', (event) => clickHandler(accordion, event.target));
        footnoteEl.classList.add(FOOTNOTE_INITIALIZED);
    }
};
